export default __webpack_public_path__ + "static/media/logout.a1e8c476.svg";